import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero/Hero';
import ServicesSection from './components/Services/ServicesSection';
import AppSection from './components/AppSection/AppSection';
import FeaturesSection from './components/Features/FeaturesSection';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import About from './components/About/About';
import ClientForm from './components/Client/ClientForm';
import ChauffeurForm from './components/Chauffeur/ChauffeurForm';
import TermsOfUse from './components/Legal/TermsOfUse';
import PrivacyPolicy from './components/Legal/PrivacyPolicy';
import Disclaimer from './components/Legal/Disclaimer';
import AboutUsPage from './pages/AboutUsPage';
import BusinessPage from './pages/BusinessPage';
import CareerPage from './pages/CareerPage';
import ChatWidget from './components/common/ChatWidget';
import FeedbackWidget from './components/feedback/FeedbackWidget';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-black">
        <Routes>
          <Route path="/" element={
            <div className="min-h-screen">
              <Hero />
              <About id="about-us" />
              <ServicesSection id="our-services" />
              <AppSection id="how-its-work" />
              <FeaturesSection id="features" />
              <Contact id="contact-us" />
              <Footer />
            </div>
          } />
          <Route path="/client" element={<ClientForm />} />
          <Route path="/chauffeur" element={<ChauffeurForm />} />
          <Route path="/business" element={<BusinessPage />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/career" element={<CareerPage />} />
        </Routes>
        <ChatWidget />
        <FeedbackWidget />
      </div>
    </Router>
  );
}

export default App;